import { useQuery } from '@tanstack/react-query';
import { fetchAnalyticsSummary, fetchDeals, fetchLeads } from '../api/resources';

export function AnalyticsPage() {
  const { data: summary } = useQuery({ queryKey: ['analytics-summary'], queryFn: fetchAnalyticsSummary });
  const { data: leads } = useQuery({ queryKey: ['leads'], queryFn: fetchLeads });
  const { data: deals } = useQuery({ queryKey: ['deals'], queryFn: fetchDeals });

  const leadByStatus = Object.entries(
    leads?.reduce<Record<string, number>>((acc, lead) => {
      acc[lead.status] = (acc[lead.status] ?? 0) + 1;
      return acc;
    }, {}) ?? {},
  );

  const revenueByStage = Object.entries(
    deals?.reduce<Record<string, number>>((acc, deal) => {
      acc[deal.stage_name] = (acc[deal.stage_name] ?? 0) + deal.value;
      return acc;
    }, {}) ?? {},
  );

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>Analytics</h1>
          <p>Revenue, pipeline velocity, and team output at a glance.</p>
        </div>
      </div>

      <div className="card-grid">
        <div className="card">
          <h3>Total leads</h3>
          <p className="stat">{summary?.leads ?? '—'}</p>
        </div>
        <div className="card">
          <h3>Deals won</h3>
          <p className="stat">{summary?.dealsWon ?? '—'}</p>
        </div>
        <div className="card">
          <h3>Revenue</h3>
          <p className="stat">${summary?.revenue?.toLocaleString() ?? '—'}</p>
        </div>
        <div className="card">
          <h3>Tasks completed</h3>
          <p className="stat">{summary?.tasksCompleted ?? '—'}</p>
        </div>
      </div>

      <div className="card">
        <h3>Lead funnel</h3>
        <table className="table">
          <thead>
            <tr>
              <th>Status</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            {leadByStatus.map(([status, count]) => (
              <tr key={status}>
                <td>{status}</td>
                <td>{count}</td>
              </tr>
            ))}
            {!leadByStatus.length && (
              <tr>
                <td colSpan={2}>No leads yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="card">
        <h3>Revenue forecast by stage</h3>
        <table className="table">
          <thead>
            <tr>
              <th>Stage</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {revenueByStage.map(([stage, value]) => (
              <tr key={stage}>
                <td>{stage}</td>
                <td>${value.toLocaleString()}</td>
              </tr>
            ))}
            {!revenueByStage.length && (
              <tr>
                <td colSpan={2}>No deals yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
